export class CuttingTable {
  id: bigint;
  type_id: number;
  name: string;
  desc: string;
  path: string;
  enviroment: string;
  param1: string;
  param2: string;
  param3: string;
  param4: string;
  sheet_load_unload_min: number;
  cut_speed_mm_s: number;
  disband_l: number;
  disband_b: number;
  disband_r: number;
  disband_t: number;
  order: number;
  active: boolean;
}
